module.exports = __webpack_public_path__ + "b9cfc2b4fe7f61bb75f7ddb6b38a401c.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/desarrollo.jpg
// module id = 638
// module chunks = 0